import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-arrow-down.svg'
import _imports_1 from '@/core/assets/icons/icon-arrow-up.svg'
import _imports_2 from '@/core/assets/social/round-facebook.svg'
import _imports_3 from '@/core/assets/social/round-google-display.svg'


const _withScopeId = n => (_pushScopeId("data-v-38061578"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "automated-retargeting" }
const _hoisted_2 = { class: "retargeting-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Automated Retargeting", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "social-bar" }
const _hoisted_6 = { class: "social-channels" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Facebook")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "facebook",
  class: "social-icon"
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Google")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "google",
  class: "social-icon"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "list" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Include people who visited pages which match any rule group", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      (!_ctx.windowIsOpen)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeWindowStatus && _ctx.changeWindowStatus(...args))),
            src: _imports_0,
            alt: "down",
            class: "arrow"
          }))
        : _createCommentVNode("", true),
      (_ctx.windowIsOpen)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeWindowStatus && _ctx.changeWindowStatus(...args))),
            src: _imports_1,
            alt: "up",
            class: "arrow"
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.windowIsOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activateChannel("facebook"))),
                style: _normalizeStyle({opacity: _ctx.activeChannel === "facebook" ? "1" : ".5"})
              }, _hoisted_9, 4),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activateChannel("google"))),
                style: _normalizeStyle({opacity: _ctx.activeChannel === "google" ? "1" : ".5"})
              }, _hoisted_12, 4)
            ])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _hoisted_14,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retargetingList, (rule) => {
              return (_openBlock(), _createElementBlock("div", { key: rule }, [
                _createElementVNode("li", null, _toDisplayString(rule), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}